<template>
  <BrandingBar :img="microImage" class="branding-bar--top-bar print-hide monoscopt" />
  <h3 class="block-title"><b>MicroEssentials®</b> Retail Value Calculator</h3>
  <CalculatorWrapper :productFormula="productFormula" :product="product" :logo="logo" />
  <BrandingBar :img="mosaicImage" class="branding-bar--bottom-bar print-hide" />
</template>

<script>
import CalculatorWrapper from '@/components/CalculatorWrapper';
import BrandingBar from '@/components/shared/BrandingBar.vue';
import productFormula from '@/assets/data/retailS15.json';

export default {
  components: {
    CalculatorWrapper,
    BrandingBar
  },
  data: function() {
    return {
      productFormula: productFormula,
      product: 'MicroEssentials S15®',
      logo:
        '//images.ctfassets.net/3jf1t80tlft4/2GaUAD1EmyLUUfHtDlhiF/e5aa2fa9a3e156f374bcb285695269ea/MicroEssentialsS15_400.png',
      microImage: window.host_domain + '/icons/microessentials-logo.svg',
      mosaicImage: window.host_domain + '/icons/mosaic.svg'
    };
  }
};
</script>
